import React from "react";

const ServiceBarChart = ({ heading, items = [] }) => {
  if (!items.length) return null;

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-5 sm:p-6">
      {heading && (
        <p className="text-xs font-semibold uppercase tracking-widest text-gray-500 mb-4 sm:mb-5">
          {heading}
        </p>
      )}
      <div className="flex flex-col gap-3 sm:gap-4">
        {items.map((item, index) => (
          <div
            key={item.label || index}
            className="flex items-center gap-3 sm:gap-4"
          >
            <span className="w-20 sm:w-32 flex-shrink-0 text-xs sm:text-sm font-medium text-gray-900">
              {item.label}
            </span>
            <span className="flex-1 h-3 sm:h-4 bg-gray-200 rounded-full overflow-hidden">
              <span
                className="block h-full rounded-full"
                style={{
                  width: `${item.value}%`,
                  backgroundColor: item.color || "#db0058",
                }}
              />
            </span>
            {item.tag && (
              <span className="w-16 sm:w-20 flex-shrink-0 text-right text-xs sm:text-sm font-bold text-gray-900">
                {item.tag}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceBarChart;
